<mat-dialog-content class="content-dialog">
    <div class="content-holder">
        <span>{{errorMessage|translate : {
            fromDate:drillDownDateRange().fromDate,
            toDate:drillDownDateRange().toDate,
            days:maxDays
            }
            }}</span>
    </div>
</mat-dialog-content>
<mat-divider class="divider-tag"></mat-divider>
<mat-dialog-actions>
    <div class="action-holder">
        <button mat-button class="select-button close-button"
            mat-dialog-close="true">{{"translation.displaymessage.close"|translate}}
        </button>
    </div>
</mat-dialog-actions>